<template>
  <Stepper
    :v-if="!loading"
    :stepInfo="stepInfo()"
    :description="currentStepDescription"
  />
</template>

<script>
import { mapState } from 'vuex'
import Stepper from '@/components/requests/Stepper'
import SurveyResponse from '@/services/surveyresponses'

export default {
  name: 'RequestStepProgressBar',
  components: {
    Stepper
  },
  props: {
    isPaypalVerify: {
      type: Boolean,
    },
    isEventCategories: {
      type: Boolean,
    },
    isCreateEvents: {
      type: Boolean,
    },
    isEventDocumentation: {
      type: Boolean,
    },
    isExpenseCategories: {
      type: Boolean,
    },
    isExpenseCategoriesAlt: {
      type: Boolean,
    },
    isExpenseDocumentation: {
      type: Boolean,
    },
    isOnboardingSurveys: {
      type: Boolean,
    },
    isRequestSummary: {
      type: Boolean,
    },
    isExpenseDocNeeded: {
      type: Boolean,
      default: true
    },
    fromOnboarding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  async created() {
    this.loading = false
  },
  methods: {
    stepCountPrediction(startNumber) {
      // this number changes with
      // 1. surveys off/on and complete or not,
      // 2. event selected
      var steps = startNumber

      if (!this.user.hasCompletedOnboardingSurveys || this.fromOnboarding)
        steps = steps + 1

      if (!this.currentRequest.requiresExpenseDocs) {
          steps = steps - 1
      }

      return steps
    },
    currentStepNumber() {
      if(this.isPaypalVerify) {
        return 1
      } else if(this.isEventCategories) {
        return 2
      } else if(this.isCreateEvents) {
        return 3
      } else if(this.isEventDocumentation) {
        return 4
      } else if(this.isExpenseCategories || this.isExpenseCategoriesAlt) {
        return 5
      } else if(this.isExpenseDocumentation) {
        return 6
      } else if(this.isOnboardingSurveys) {
        return this.stepCountPrediction(6)
      } else if(this.isRequestSummary) {
        return this.stepCountPrediction(7)
      }
    },
    stepInfo() {
      let msg = this.$gettext('Step %{currentStepNumber} of %{stepCountPrediction}');
      const placeholders = {
        currentStepNumber: this.currentStepNumber(),
        stepCountPrediction: this.stepCountPrediction(7)
      }
      return this.$gettextInterpolate(msg, placeholders);
    },
  },

  computed: {

    currentStepDescription() {
      if(this.isPaypalVerify) {
        return this.$gettext("Make sure you can receive money")
      } else if(this.isEventCategories) {

        if (this.organizationDetails && this.organizationDetails.eventsTitle) {
            return this.organizationDetails.eventsTitle
        } else {
          return this.$gettext("Describe your emergency")
        }
      } else if(this.isCreateEvents) {
        return this.$gettext("Add details")
      } else if(this.isEventDocumentation) {
        if (this.organizationDetails && this.organizationDetails.eventDocumentsTitle) {
            return this.organizationDetails.eventDocumentsTitle
        } else {
          return this.$gettext("Document your emergency")
        }
      } else if(this.isExpenseCategories) {
        return this.$gettext("Document expenses and amounts needed")
      } else if(this.isExpenseCategoriesAlt) {
        return this.$gettext("Describe expenses and amounts needed")
      } else if(this.isExpenseDocumentation) {
        return this.$gettext("Document your expenses")
      } else if(this.isOnboardingSurveys) {
        return this.$gettext("Enrollment Questionnaires")
      } else if(this.isRequestSummary) {
        return this.$gettext("Request Summary")
      }
    },
    ...mapState(['user', 'organizationDetails', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.step-progress-bar {
  display: flex;
  justify-content: center;

  .step-wrapper {
    @include tablet-and-up-screen {
      max-width: 70%;
    }
  }

  .step-number-text {
    font-size: 1.25rem;
    line-height: 1.75rem;

    @include desktop-screen {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  .step-description-text {
    font-size: 2rem;
    font-weight: bold;
    line-height: 2.5rem;

    @include tablet-screen {
      font-size: 2.25rem;
      line-height: 2.8rem;
    }

    @include desktop-screen {
      font-size: 3rem;
      line-height: 3.75rem;
    }
  }
}
</style>
